<app-navigation-header title="Usage Report" i18n-title="@@usageReport-title">
	<app-data-set
		#dataSet
		[dataSource]="dataSource"
		defaultPresentationMode="table"
		[appBreadcrumbLabel]="breadcrumbLabel"
		[rowId]="rowId"
		firstColumnProperty="companyName"
	>
		<app-data-set-toolbar>
			<div class="flex-space-around">
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						svgIcon="sl-filter"
						label="Refine Filters"
						i18n-label="@@usageReport-refineFilter"
						(click)="onRefineFiltersClicked()"
						data-automation-id="usage-report-refine-filters-button"
					></app-data-set-action-button>
				</div>
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						svgIcon="sl-download"
						label="Download"
						i18n-label="@@usageReport-download"
						(click)="onDownloadClicked()"
						data-automation-id="usage-report-download-button"
					></app-data-set-action-button>
				</div>
			</div>
		</app-data-set-toolbar>

		<app-data-set-content>
			<app-data-set-table-view>
				@if (
					loadingService.isLoading(generateUsageReportLoadingKey) ||
					loadingService.isLoading(generateUsageReportCsvLoadingKey) ||
					!finishedLoadingInitData
				) {
					<app-data-set-loading-row />
				}
				<table
					mat-table
					[dataSource]="dataSource"
					matSort
					[hidden]="
						loadingService.isLoading(generateUsageReportLoadingKey) ||
						loadingService.isLoading(generateUsageReportCsvLoadingKey) ||
						!finishedLoadingInitData
					"
				>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
							No records found.
						</td>
					</tr>
					<ng-container matColumnDef="companyName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@usageReport-companyName">Device Owner</th>
						<td mat-cell *matCellDef="let row">{{ row.companyName }}</td>
					</ng-container>

					<ng-container matColumnDef="totalAccesses">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@usageReport-totalAccesses">Total Accesses</th>
						<td mat-cell *matCellDef="let row">{{ row.totalAccesses }}</td>
					</ng-container>

					<ng-container matColumnDef="totalDevices">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@usageReport-totalDevicesHeader">
							Total Devices
						</th>
						<td mat-cell *matCellDef="let row">{{ row.totalDevices }} {{ row.generatedByLastName }}</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				</table>
			</app-data-set-table-view>
		</app-data-set-content>
	</app-data-set>
</app-navigation-header>
